<ng-container *ngIf="showInstructionBanner() || shouldShowPendingCallBanner || shouldShowUnpaidLlmChatBanner">
  <div [ngClass]="getContainerClassView() ? '' : 'tw-my-2 tw-bg-white tw-pt-4 tw-pb-4'">
    <ng-container *ngIf="shouldShowUnpaidLlmChatBanner && newBannerUI">
      <section class="tw-p-4 tw-bg-white tw-mb-3 tw-mt-2">
        <app-user-query-chat-banner [noGradientHeader]="true" [supportView]="supportView" [user]="user" [showHeader]="(shouldShowPendingCallBanner && pendingCallState) || (!shouldShowPendingCallBanner && !pendingCallState)" [regimen]="userRegimen"></app-user-query-chat-banner>
      </section>
    </ng-container>
    @if(showInstructionBanner()) {
      <app-regimen-instruction-banner [class]="(shouldShowUnpaidLlmChatBanner && newBannerUI) ? '' : 'tw-block tw-mt-4'" [regimenClass]="displayRegimenForBanner?.class ?? userRegimen.class" [username]="user.get('username')" [regimenBackgroundColor]="regimenBackgroundColor" [regimenKitImage]="regimenKitImage"></app-regimen-instruction-banner>
    }
    <ng-container *ngIf="shouldShowPendingCallBanner">
      <ng-container *ngIf="!pendingCallState">
        <section [ngClass]="newBannerUI ? '' : 'tw-bg-white'" class="tw-px-4 tw-pb-5">
          <app-request-call-banner [supportView]="supportView" [experimentVariantData]="pendingCallBannerExperimentVariantData" [regimen]="userRegimen" [regimenClass]="regimenClass" (pendingCallCreated)="onPendingCallCreated()"></app-request-call-banner>
        </section>
      </ng-container>
      <ng-container *ngIf="pendingCallState">
        <section [ngClass]="pendingCallBannerExperimentVariantData?.newBannerUI ? 'tw-px-4 tw-pb-5 tw-pt-1' : 'tw-px-4 tw-pb-2 tw-mb-2 tw-bg-white'">
          <ng-container *ngIf="pendingCallState === this.appConfig.Shared.PendingCall.Status.Requested">
            <app-call-scheduled-banner [newUI]="pendingCallBannerExperimentVariantData?.newBannerUI"></app-call-scheduled-banner>
          </ng-container>
          <ng-container *ngIf="pendingCallState === this.appConfig.Shared.PendingCall.Status.CallCompleted">
            <app-call-completed-banner></app-call-completed-banner>
          </ng-container>
          <ng-container *ngIf="pendingCallState === this.appConfig.Shared.PendingCall.Status.CallLater || pendingCallState === this.appConfig.Shared.PendingCall.Status.NotReachable">
            <app-doctor-call-unsuccessful-banner [status]="pendingCallState"></app-doctor-call-unsuccessful-banner>
          </ng-container>
        </section>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="shouldShowUnpaidLlmChatBanner && !newBannerUI">
      <section class="tw-px-4 tw-bg-white">
        <app-user-query-chat-banner [supportView]="supportView" [user]="user" [showHeader]="(shouldShowPendingCallBanner && pendingCallState) || (!shouldShowPendingCallBanner && !pendingCallState)" [regimen]="userRegimen"></app-user-query-chat-banner>
      </section>
    </ng-container>
  </div>
</ng-container>
